import * as Sentry from "@sentry/react";
import { env } from "@/env";
import type { AppRouter } from "@/Router";

const capitalize = (s?: string) =>
  typeof s === "string" && s.length > 0
    ? s.charAt(0).toUpperCase() + s.slice(1)
    : (s ?? "");

export const initSentry = (router: AppRouter, dsnUrl: string | undefined) => {
  if (!dsnUrl) {
    return;
  }
  Sentry.init({
    dsn: dsnUrl,
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: false,
    initialScope: {
      tags: {
        environment: capitalize(env.mode),
        app_version: __APP_VERSION__,
        commit_hash: __COMMIT_HASH__,
        portal: "kundeportal",
      },
    },
    environment: capitalize(env.mode),
    integrations: [
      Sentry.tanstackRouterBrowserTracingIntegration(router),
      //Sentry.replayIntegration(),
      Sentry.eventFiltersIntegration(),
      Sentry.breadcrumbsIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ["error"] }),
    ],
    // Enable logs to be sent to Sentry
    enableLogs: true,
    // Ignore server errors logs that would either way be more detailed in backend
    // I.e. Validation errors are sent as 422
    ignoreErrors: ["422 (Unprocessable Entity)"],
    //  performance
    // Set tracesSampleRate to 1.0 to capture 100% of transactions for performance monitoring.
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: 0.05,
    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [
      "localhost",
      /^\//,
      /^https:\/\/(.*)api\.norgespris-fjernvarme\.no/,
    ],
    //  performance
    //  session-replay
    // Capture Replay for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    // replaysOnErrorSampleRate: 1.0,
    //  session-replay
  });
};
